import { BrowserLogger } from "./browserLogger";

export const eventLogger = new BrowserLogger()